/**
 * Bundle Price Display Manager
 * Handles price display updates for bundle pricing A/B test
 */

class BundlePriceDisplay {
  constructor() {
    this.init();
  }
  
  init() {
    // On bundle-enabled products, bundle-pricing.js also listens for
    // variant:change and calls updateBundlePrices() directly after its own
    // handling — registering a second, un-debounced listener here doubled
    // the synchronous work done per interaction (INP). Only self-register
    // when bundle-pricing.js's manager isn't going to drive updates.
    if (!document.querySelector('script[src*="bundle-pricing.js"]')) {
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    // Initialize on page load
    this.updateBundlePrices();
  }
  
  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;
    
    this.updateBundlePrices(variant);
  }
  
  updateBundlePrices(variant = null) {
    // Find all bundle price containers
    const bundlePriceContainers = document.querySelectorAll('[data-bundle-pricing="true"]');
    
    bundlePriceContainers.forEach(container => {
      this.updateSingleBundlePrice(container, variant);
    });
  }
  
  updateSingleBundlePrice(container, variant) {
    // Get bundle pricing data
    const hasBundlePricing = container.dataset.bundlePricing === 'true';
    if (!hasBundlePricing) return;
    
    // Get the lowest bundle price (this is the target bundle price from the liquid calculation)
    const lowestBundlePrice = parseFloat(container.dataset.bundleLowestPrice);
    if (!lowestBundlePrice) return;
    
    // Get the original product price from the data attribute
    const originalProductPrice = parseFloat(container.dataset.originalProductPrice);
    
    if (!originalProductPrice) {
      console.error('Bundle price display: Original product price not found');
      return;
    }
    
    // Calculate the discount ratio from the original bundle calculation
    const bundleDiscountRatio = lowestBundlePrice / originalProductPrice;
    
    // Get current variant price
    let currentPrice = originalProductPrice;
    if (variant && variant.price) {
      currentPrice = variant.price;
    }
    
    // Apply the same discount ratio to the new variant price
    const newBundlePrice = Math.round(currentPrice * bundleDiscountRatio);
    
    // Update the displayed price
    const priceElement = container.querySelector('.price-item--regular');
    if (priceElement) {
      // Format the price
      const formattedPrice = this.formatMoney(newBundlePrice);
      
      // Always show "From" prefix for bundle pricing
      priceElement.innerHTML = '<span class="bundle-price-prefix">From</span> ' + formattedPrice;
    }
  }
  
  formatMoney(cents) {
    // Get money format from Shopify
    const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
    
    // Convert cents to dollars
    const dollars = (cents / 100).toFixed(2);
    
    // Apply format
    let formatted = moneyFormat.replace('{{amount}}', dollars);
    formatted = formatted.replace('{{amount_no_decimals}}', Math.floor(cents / 100));
    formatted = formatted.replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
    
    return formatted;
  }
}

// Initialize when DOM is ready, and expose globally so bundle-pricing.js can
// call updateBundlePrices() directly from its own debounced variant:change path.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.bundlePriceDisplay = new BundlePriceDisplay();
  });
} else {
  window.bundlePriceDisplay = new BundlePriceDisplay();
}